import { Grid } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import ButtonDelete from "components/Buttons/ButtonDelete";
import ButtonEdit from "components/Buttons/ButtonEdit";
import ButtonPublish from "components/Buttons/ButtonPublish";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps {
    data: FeedItemDto;
    fullView: boolean;
    onEditPublication?: () => void;
    onDeletePublication?: () => void;
    onPublishPublication?: () => void;
}

type Props = IProps & StyledComponentProps<FeedClassKey> & WithSnackbar;

/////////////////////////////////////////////////////////////////////////////////////

class ActionsDraftContent extends React.PureComponent<Props, IState> {

    public render() {

        return (
            <Grid container justifyContent="space-between">
                {
                    this.props.onEditPublication &&
                    <Grid item>
                        <ButtonEdit
                            color="transparent"
                            onClick={this.props.onEditPublication}
                        />
                    </Grid>
                }

                {
                    this.props.onPublishPublication &&
                    <Grid item>
                        <ButtonPublish
                            color="transparent"
                            onClick={this.props.onPublishPublication}
                        />
                    </Grid>
                }

                {
                    this.props.onDeletePublication &&
                    <Grid item>
                        <ButtonDelete
                            color="transparent"
                            onClick={this.props.onDeletePublication}
                        />
                    </Grid>
                }

            </Grid>
        );
    }
}

export default withSnackbar(ActionsDraftContent);
